/* ============================================
   HYDE Index Page Section Scripts
   ============================================ */

(function () {
  "use strict";

  if (window.__hydeIdxBooted) return;
  window.__hydeIdxBooted = true;

  // Listen for live reduced-motion preference changes
  window
    .matchMedia("(prefers-reduced-motion: reduce)")
    .addEventListener("change", function (e) {
      prefersReducedMotion = e.matches;
      document
        .querySelectorAll(".hyde-idx__marquee-row[data-animate='true']")
        .forEach(function (row) {
          row.style.animationPlayState = prefersReducedMotion
            ? "paused"
            : "running";
        });
    });

  let prefersReducedMotion = window.matchMedia(
    "(prefers-reduced-motion: reduce)",
  ).matches;
  const observerOptions = {
    threshold: 0.05,
    rootMargin: "0px 0px 50px 0px",
  };

  function getAnime() {
    if (!window.anime) return null;
    if (typeof window.anime === "function") return window.anime;
    if (typeof window.anime.animate === "function") return window.anime;
    return null;
  }

  function runAnime(anime, options) {
    if (!anime) return null;
    if (typeof anime === "function") return anime(options);
    const { targets, ...params } = options;
    return anime.animate(targets, params);
  }

  function createTimeline(anime, options) {
    if (!anime) return null;
    if (typeof anime === "function" && typeof anime.timeline === "function") {
      return anime.timeline(options || {});
    }
    if (typeof anime.createTimeline === "function") {
      return anime.createTimeline(options || {});
    }
    return null;
  }

  function getStagger(anime, value, options) {
    if (!anime || typeof anime.stagger !== "function") return 0;
    return anime.stagger(value, options || {});
  }

  function isAnimated(el) {
    return Boolean(el) && el.dataset.hydeAnimated === "true";
  }

  function markAnimated(el) {
    if (!el) return;
    el.dataset.hydeAnimated = "true";
  }

  function clearAnimatedStyles(el) {
    if (!el) return;
    el.style.opacity = "";
    el.style.transform = "";
    el.style.willChange = "";
  }

  function finalizeAnimation(el) {
    if (!el) return;
    markAnimated(el);
    clearAnimatedStyles(el);
  }

  function getTargets(scope, selector) {
    const targets = [];

    if (scope instanceof Element && scope.matches(selector)) {
      targets.push(scope);
    }

    if (!scope || !scope.querySelectorAll) {
      return targets;
    }

    return targets.concat(Array.from(scope.querySelectorAll(selector)));
  }

  function getStaggerChildren(container) {
    if (!container) return [];
    return Array.from(container.children);
  }

  function revealImmediately(el) {
    if (!el || isAnimated(el)) return;
    finalizeAnimation(el);
  }

  function revealStaggerImmediately(container) {
    if (!container || isAnimated(container)) return;

    markAnimated(container);
    getStaggerChildren(container).forEach(clearAnimatedStyles);
  }

  function animateReveal(el, options) {
    if (!el || isAnimated(el)) return;

    if (prefersReducedMotion) {
      revealImmediately(el);
      return;
    }

    const anime = getAnime();
    if (!anime) {
      revealImmediately(el);
      return;
    }

    el.style.willChange = "opacity, transform";

    runAnime(anime, {
      targets: el,
      opacity: [0, 1],
      translateY: [options && options.distance ? options.distance : 24, 0],
      duration: options && options.duration ? options.duration : 860,
      delay: options && options.delay ? options.delay : 0,
      easing: options && options.easing ? options.easing : "outElastic",
      complete: function () {
        finalizeAnimation(el);
      },
    });
  }

  function animateStagger(container, options) {
    if (!container || isAnimated(container)) return;

    const children = getStaggerChildren(container);
    if (!children.length) {
      markAnimated(container);
      return;
    }

    if (prefersReducedMotion) {
      revealStaggerImmediately(container);
      return;
    }

    const anime = getAnime();
    if (!anime) {
      revealStaggerImmediately(container);
      return;
    }

    children.forEach((child) => {
      child.style.willChange = "opacity, transform";
    });

    runAnime(anime, {
      targets: children,
      opacity: [0, 1],
      translateY: [options && options.distance ? options.distance : 18, 0],
      duration: options && options.duration ? options.duration : 640,
      delay: getStagger(
        anime,
        options && options.stagger ? options.stagger : 80,
        {
          start: options && options.delay ? options.delay : 0,
        },
      ),
      easing: options && options.easing ? options.easing : "outElastic",
      complete: function () {
        markAnimated(container);
        children.forEach(clearAnimatedStyles);
      },
    });
  }

  const animObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const target = entry.target;

            if (target.classList.contains("hyde-idx__anim-stagger")) {
              animateStagger(target, {
                distance: 18,
                duration: 640,
                stagger: 80,
              });
            } else {
              animateReveal(target, {
                distance: 24,
                duration: 860,
              });
            }

            animObserver.unobserve(target);
          });
        }, observerOptions)
      : null;

  function observeAnimationTarget(target) {
    if (!target || isAnimated(target)) return;

    if (prefersReducedMotion || !animObserver) {
      if (target.classList.contains("hyde-idx__anim-stagger")) {
        animateStagger(target, {
          distance: 18,
          duration: 640,
          stagger: 80,
        });
      } else {
        animateReveal(target, {
          distance: 24,
          duration: 860,
        });
      }

      return;
    }

    animObserver.observe(target);
  }

  function initAnimations(scope) {
    const root = scope || document;

    getTargets(root, ".hyde-idx__anim").forEach((target) => {
      observeAnimationTarget(target);
    });

    getTargets(root, ".hyde-idx__anim-stagger").forEach((target) => {
      observeAnimationTarget(target);
    });
  }

  const videoObserver =
    "IntersectionObserver" in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                video.play().catch(function () {});
              } else {
                video.pause();
              }
            });
          },
          { threshold: 0.2 },
        )
      : null;

  function initVideos(scope) {
    getTargets(scope || document, ".hyde-idx__radial-center-video").forEach(
      function (video) {
        if (videoObserver) {
          videoObserver.observe(video);
        } else {
          video.play().catch(function () {});
        }
      },
    );
  }

  function initMarquee(scope) {
    getTargets(scope || document, ".hyde-idx__marquee-row").forEach((row) => {
      const children = Array.from(row.children);
      if (!children.length || row.dataset.cloned === "true") return;

      // Calculate how many clones needed to fill at least 2x viewport
      var setWidth = 0;
      children.forEach(function (c) {
        setWidth += c.offsetWidth;
      });
      var gap = parseFloat(getComputedStyle(row).gap) || 0;
      setWidth += gap * children.length;
      var copies = Math.ceil((window.innerWidth * 2) / setWidth) + 1;
      if (copies < 1) copies = 1;

      for (var c = 0; c < copies; c += 1) {
        var fragment = document.createDocumentFragment();
        for (var i = 0; i < children.length; i += 1) {
          fragment.appendChild(children[i].cloneNode(true));
        }
        row.appendChild(fragment);
      }

      row.dataset.cloned = "true";
      if (prefersReducedMotion) return;
      row.dataset.animate = "true";
    });
  }

  function boot(scope) {
    const root = scope || document;
    if (!getTargets(root, ".hyde-idx").length) return;
    initAnimations(root);
    initMarquee(root);
    initVideos(root);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    boot(event.target);
  });
})();
